(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement{
    constructor(){super()}
    connectedCallback(){
      this.header=document.querySelector('.section-header')
      this.headerIsAlwaysSticky=this.getAttribute('data-sticky-type')==='always'||this.getAttribute('data-sticky-type')==='reduce-logo-size'
      this.headerBounds={}
      this.setHeaderHeight()
      window.matchMedia('(max-width: 990px)').addEventListener('change',this.setHeaderHeight.bind(this))
      if(this.headerIsAlwaysSticky){this.header.classList.add('shopify-section-header-sticky')}
      this.currentScrollTop=0
      this.preventReveal=false
      this.predictiveSearch=this.querySelector('predictive-search')
      this.onScrollHandler=this.onScroll.bind(this)
      this.hideHeaderOnScrollUp=()=> (this.preventReveal=true)
      this.addEventListener('preventHeaderReveal',this.hideHeaderOnScrollUp)
      window.addEventListener('scroll',this.onScrollHandler,false)
      this.createObserver()
    }
    setHeaderHeight(){document.documentElement.style.setProperty('--header-height',`${this.header.offsetHeight}px`)}
    disconnectedCallback(){
      this.removeEventListener('preventHeaderReveal',this.hideHeaderOnScrollUp)
      window.removeEventListener('scroll',this.onScrollHandler)
    }
    createObserver(){
      let observer=new IntersectionObserver((entries,observer)=>{this.headerBounds=entries[0].intersectionRect;observer.disconnect()})
      observer.observe(this.header)
    }
    onScroll(){
      const scrollTop=window.pageYOffset||document.documentElement.scrollTop
      if(this.predictiveSearch&&this.predictiveSearch.isOpen)return
      if(scrollTop>this.currentScrollTop&&scrollTop>this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header')
        if(this.preventHide)return
        requestAnimationFrame(this.hide.bind(this))
      }else if(scrollTop<this.currentScrollTop&&scrollTop>this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header')
        if(!this.preventReveal){requestAnimationFrame(this.reveal.bind(this))}
        else{
          window.clearTimeout(this.isScrolling)
          this.isScrolling=setTimeout(()=>{this.preventReveal=false},66)
          requestAnimationFrame(this.hide.bind(this))
        }
      }else if(scrollTop<=this.headerBounds.top){
        this.header.classList.remove('scrolled-past-header')
        requestAnimationFrame(this.reset.bind(this))
      }
      this.currentScrollTop=scrollTop
    }
    hide(){
      if(this.headerIsAlwaysSticky)return
      this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky')
      this.closeMenuDisclosure()
      this.closeSearchModal()
    }
    reveal(){
      if(this.headerIsAlwaysSticky)return
      this.header.classList.add('shopify-section-header-sticky','animate')
      this.header.classList.remove('shopify-section-header-hidden')
    }
    reset(){
      if(this.headerIsAlwaysSticky)return
      this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate')
    }
    closeMenuDisclosure(){
      this.disclosures=this.disclosures||this.header.querySelectorAll('header-menu')
      this.disclosures.forEach((d)=>d.close())
    }
    closeSearchModal(){
      this.searchModal=this.searchModal||this.header.querySelector('details-modal')
      this.searchModal.close(false)
    }
  }
  customElements.define('sticky-header',StickyHeader)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-4cards"] && !Shopify.designMode) return;
  try {
    
  // Optional JavaScript for your section
  console.log('Promises section loaded!');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-customer-service"] && !Shopify.designMode) return;
  try {
    
  // Optional JavaScript for this section
  console.log('Cu-Service - Two Custom Grids section loaded!');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-2ndslider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sliderSections = document.querySelectorAll('.image-slider-section');

  sliderSections.forEach(section => {
    const slider = section.querySelector('.image-slider');
    const slides = section.querySelectorAll('.slide');
    const prevButton = section.querySelector('.prev-slide');
    const nextButton = section.querySelector('.next-slide');
    let currentIndex = 0;
    let autoplayInterval;

    function showSlide(index) {
      slides.forEach(slide => slide.style.display = 'none');
      slides[index].style.display = 'block';
    }

    function nextSlide() {
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    }

    function prevSlide() {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(currentIndex);
    }

    function startAutoplay() {
      const autoplaySpeed = parseInt(section.dataset.autoplaySpeed) * 1000;
      autoplayInterval = setInterval(nextSlide, autoplaySpeed);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    if (slides.length > 0) {
      showSlide(currentIndex); // Show the initial slide

      if (nextButton && prevButton) {
        nextButton.addEventListener('click', () => {
          stopAutoplay();
          nextSlide();
        });
        prevButton.addEventListener('click', () => {
          stopAutoplay();
          prevSlide();
        });
      }

      const autoplayEnabled = section.dataset.autoplay === 'true';
      if (autoplayEnabled && slides.length > 1) {
        startAutoplay();
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-benifits"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabHeaders = document.querySelectorAll('.collapsible-tabs .tab-header');
  const benefitsSectionBelow = document.querySelector('.benefits-section.below-banner');
  const usesSectionBelow = document.querySelector('.uses-section.below-banner');

  tabHeaders.forEach(header => {
    const button = header.querySelector('.tab-button');
    const contentId = button.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    const sectionBelow = (contentId === 'benefits-content') ? benefitsSectionBelow : usesSectionBelow;

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true' || false;
      button.setAttribute('aria-expanded', !expanded);
      content.hidden = expanded;
      sectionBelow.style.display = expanded ? 'none' : 'block';
    });
  });

  benefitsSectionBelow.style.display = 'none';
  usesSectionBelow.style.display = 'none';
});

  } catch(e) { console.error(e); }
})();
})();
